import { render, staticRenderFns } from "./AwardModal.vue?vue&type=template&id=59da7307"
import script from "./AwardModal.vue?vue&type=script&lang=js"
export * from "./AwardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports